import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { borderColors, fontColors } from '@sphereon/ui-components.core';
import { getIcon } from '../../../utils';
import { DropDownListItemCaptionContainerStyled as ListItemCaption, DropDownListItemContainerStyled as Container, DropDownListItemIconContainerStyled as IconContainer, } from '../../../styles/components';
const DropDownListItem = (props) => {
    const { disabled, label, icon, showBorder = false, fontColor = fontColors.dark, borderColor = borderColors.light, onClick } = props;
    const onContainerClick = async (event) => {
        event.stopPropagation();
        if (onClick) {
            await onClick();
        }
    };
    return (_jsxs(Container, { onClick: onContainerClick, style: { ...(showBorder && { borderBottomWidth: 2, borderBottomColor: borderColor }) }, children: [_jsx(ListItemCaption, { children: label }), icon && _jsx(IconContainer, { children: getIcon(icon) })] }));
};
export default DropDownListItem;
